import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { DEFAULT_LOCALE, DEFAULT_OG_IMAGE, SITE_NAME } from './siteConfig'
import { canonicalUrl, getSeoForPath } from './seoConfig'

const Seo = ({ title, description, path, noindex }) => {
  const { pathname } = useLocation()
  const seo = getSeoForPath(pathname)

  const pageTitle = title ?? seo.title
  const pageDescription = description ?? seo.description
  const pagePath = path ?? seo.path ?? pathname
  const canonical = canonicalUrl(pagePath)
  const shouldNoindex = noindex ?? seo.noindex ?? false

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name='description' content={pageDescription} />
      <link rel='canonical' href={canonical} />

      {shouldNoindex ? (
        <meta name='robots' content='noindex, follow' />
      ) : (
        <meta name='robots' content='index, follow' />
      )}

      <meta property='og:type' content='website' />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:title' content={pageTitle} />
      <meta property='og:description' content={pageDescription} />
      <meta property='og:url' content={canonical} />
      <meta property='og:image' content={DEFAULT_OG_IMAGE} />
      <meta property='og:locale' content={DEFAULT_LOCALE} />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={pageTitle} />
      <meta name='twitter:description' content={pageDescription} />
      <meta name='twitter:image' content={DEFAULT_OG_IMAGE} />

      <meta name='geo.region' content='AU-NSW' />
      <meta name='geo.placename' content='Newcastle' />
    </Helmet>
  )
}

export default Seo
